<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
@if (catalog) {
<div>
  <div class="table-container">
    <table mat-table [dataSource]="catalogUnitList">
      <!-- action column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="column-action">&nbsp;</th>
        <td mat-cell *matCellDef="let element" class="column-action">
          @if (canEdit) {
          <button mat-icon-button (click)="removeUnitFromCatalog(element.id); $event.stopPropagation();"
            title="Remove {{ getUnit(element.unitId).shortName }} from this catalog">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-minus-circle-outline"></mat-icon>
          </button>
          }
        </td>
      </ng-container>
      <!-- shortName Column -->
      <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef class="column-short-name">Short Name</th>
        <td mat-cell *matCellDef="let element" class="column-short-name">
          {{ getUnit(element.unitId).shortName }}
        </td>
      </ng-container>
      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="column-name">Name</th>
        <td mat-cell *matCellDef="let element" class="column-name">
          {{ getUnit(element.unitId).name }}
        </td>
      </ng-container>
      <!-- row definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
    </table>
    @if (catalogUnitList.length === 0) {
    <div class="no-units">No units have access</div>
    }
  </div>
  @if (canEdit) {
  <div class="add-unit-container">
    <mat-expansion-panel>
      <mat-expansion-panel-header (click)="$event.stopPropagation();">
        Add a Unit
      </mat-expansion-panel-header>
      @for (unit of getUnitList(); track trackByFn($index, unit)) {
      <div class="other-units-div">
        <button mat-icon-button (click)="addUnitToCatalog(unit.id); $event.stopPropagation();"
          title="Add {{ unit.shortName }} to this catalog" [disabled]="!canEdit">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle-outline"></mat-icon>
        </button>
        <span class="center-self">{{ unit.shortName }} - {{ unit.name }}</span>
      </div>
      }
    </mat-expansion-panel>
  </div>
  }
</div>
}
